/**
 * READ THIS! IF YOU ARE A REACT DEVELOPER YOU SHOULD
 *  https://joshwcomeau.com/react/the-perils-of-rehydration
 */

import React from 'react';

export default function ClientOnly({children, ...delegated}) {
  const [hasMounted, setHasMounted] = React.useState(false);
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }
  return <div {...delegated}>{children}</div>;
}
